<template>
  <div v-loading="loading">
    <el-button
      size="mini"
      type="primary"
      style="margin-left: 92%;"
      @click="refsh"
      >{{ $t("lang.repeater.refsh") }}</el-button
    >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('lang.repeater.universal')" name="first">
        <div class="currency">
          <p v-if="master">{{ $t("lang.repeater.serverConfig") }}</p>
          <el-form
            ref="server"
            v-if="master"
            :model="serverOption"
            label-width="100px"
            :rules="rules"
          >
            <el-form-item :label="$t('lang.repeater.enable')">
              <el-checkbox v-model="serverOption.enabled"></el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('lang.repeater.operatingModel')">
              <el-select
                class="input"
                size="mini"
                v-model="serverOption.net_proto"
              >
                <el-option label="TCP" value="TCP"></el-option>
                <!-- <el-option label="UDP" value="UDP"></el-option> -->
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('lang.repeater.protocol')">
              <el-select class="input" size="mini" v-model="serverOption.proto">
                <el-option label="ZING" value="ZING"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('lang.repeater.serverAddress')"
              prop="server"
            >
              <div v-for="i in serverOption.server.length">
                <el-input
                  class="input"
                  size="mini"
                  v-model="serverOption.server[i - 1]"
                ></el-input>
                <el-button
                  size="mini"
                  type="danger"
                  style="margin-left: 10px;"
                  v-if="i != serverOption.server.length"
                  icon="el-icon-minus"
                  @click="removeClick(i)"
                ></el-button>
                <el-button
                  size="mini"
                  type="primary"
                  style="margin-left: 10px;"
                  v-if="i == serverOption.server.length"
                  @click="addServer"
                  icon="el-icon-plus"
                ></el-button>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('lang.repeater.heartbeatCycle')"
              prop="hbt_interval"
            >
              <el-input
                class="input"
                size="mini"
                v-model="serverOption.hbt_interval"
              ></el-input>
              <p style="font-size: 12px;color: #818e8e;">
                {{ $t("lang.repeater.second") }}
              </p>
            </el-form-item>
            <el-form-item :label="$t('lang.repeater.state')">{{
              serverOption.status
                ? serverOption.status == "disconnected"
                  ? $t("lang.repeater.noConnect")
                  : serverOption.status
                : $t("lang.repeater.noConnect")
            }}</el-form-item>
            <el-form-item :label="$t('lang.repeater.connectNumber')">{{
              serverOption.conn_num ? serverOption.conn_num : "-"
            }}</el-form-item>
          </el-form>
          <p>{{ $t("lang.repeater.relayConfig") }}</p>
          <el-table
            border
            :data="dataOption"
            style="width: 100%;margin-top: 20px;"
          >
            <el-table-column :label="$t('lang.repeater.enable')" width="60">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.enabled"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('lang.repeater.reportTerminal')"
              width="100"
            >
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.upload_term"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.repeater.name')">
              <template slot-scope="scope">
                <el-form :model="scope.row" :rules="rules4" ref="zh_name">
                  <el-form-item prop="name">
                    <el-input
                      size="mini"
                      v-model.number="scope.row.name"
                      placeholder="0~31"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.repeater.operatingModel')">
              <template slot-scope="scope">
                <el-form :model="scope.row">
                  <el-form-item
                    ><el-select size="mini" v-model="scope.row.net_proto">
                      <el-option label="TCP" value="TCP"></el-option>
                      <el-option
                        label="UDP"
                        value="UDP"
                      ></el-option> </el-select
                  ></el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.repeater.listenPort')">
              <template slot-scope="scope">
                <el-form :model="scope.row" :rules="rules3" ref="port">
                  <el-form-item prop="port_recv">
                    <el-input
                      placeholder="0~65535"
                      size="mini"
                      v-model="scope.row.port_recv"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.repeater.sendTo')" width="360">
              <template slot-scope="scope">
                <el-form :model="scope.row" :rules="rules2" ref="sendto">
                  <el-form-item prop="sendto">
                    <el-input
                      size="mini"
                      v-model="scope.row.sendto"
                      :placeholder="$t('lang.repeater.ipRules')"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.repeater.del')" width="80">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="removeData(scope.$index)"
                  >{{ $t("lang.repeater.del") }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-button
            type="primary"
            style="margin-top: 20px;"
            @click="addData"
            >{{ $t("lang.repeater.add") }}</el-button
          >
          <p style="margin-top: 20px;" v-if="serial">
            {{ $t("lang.repeater.serailConfig") }}
          </p>
          <el-table
            :data="serialData"
            border
            style="width: 100%;margin-top: 20px;"
            v-if="serial"
          >
            <el-table-column :label="$t('lang.repeater.interface')" prop="comm">
            </el-table-column>
            <el-table-column
              :label="$t('lang.repeater.baudrate')"
              prop="baudrate"
            >
            </el-table-column>
            <el-table-column
              :label="$t('lang.repeater.data_bits')"
              prop="data_bits"
            >
            </el-table-column>
            <el-table-column
              :label="$t('lang.repeater.stop_bits')"
              prop="stop_bits"
            >
            </el-table-column>
            <el-table-column :label="$t('lang.repeater.parity')" prop="parity">
              <template slot-scope="scope">
                {{ scope.row.parity | customFilter }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.repeater.flow')" prop="flow_ctrl">
              <template slot-scope="scope">
                {{ scope.row.flow_ctrl | customFilter }}
              </template>
            </el-table-column>
            <el-table-column prop="baudrate">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  @click="editComClick(scope.row)"
                  size="mini"
                  >{{ $t("lang.repeater.edit") }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('lang.repeater.adv')" name="second">
        <div class="currency">
          <p>{{ $t("lang.repeater.advConfig") }}</p>
          <el-form
            :model="seniorData"
            label-width="180px"
            ref="currency"
            :rules="rules5"
          >
            <el-form-item :label="$t('lang.repeater.trueOn')" prop="enabled">
              <el-checkbox v-model="seniorData.enabled"></el-checkbox>
            </el-form-item>
            <el-form-item
              :label="$t('lang.repeater.debug')"
              prop="enable_debug"
            >
              <el-checkbox v-model="seniorData.enable_debug"></el-checkbox
            ></el-form-item>
            <el-form-item
              :label="$t('lang.repeater.tcpKeep')"
              prop="tcp_keepalive_time"
            >
              <el-input
                size="mini"
                class="input"
                v-model="seniorData.tcp_keepalive_time"
              ></el-input>
              <p style="font-size:12px;color:#666;">
                {{ $t("lang.repeater.sec") }}
              </p>
            </el-form-item>
            <el-form-item
              :label="$t('lang.repeater.tcpKeep2')"
              prop="tcp_keepalive_interval"
            >
              <el-input
                size="mini"
                class="input"
                v-model="seniorData.tcp_keepalive_interval"
              ></el-input>
              <p style="font-size:12px;color:#666;">
                {{ $t("lang.repeater.sec") }}
              </p>
            </el-form-item>
            <el-form-item
              :label="$t('lang.repeater.tcpKeep3')"
              prop="tcp_keepalive_probes"
            >
              <el-input
                size="mini"
                class="input"
                v-model="seniorData.tcp_keepalive_probes"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('lang.repeater.logNumber')"
              prop="log_file_num"
            >
              <el-input
                size="mini"
                class="input"
                v-model="seniorData.log_file_num"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('lang.repeater.logSize')"
              prop="log_file_size"
            >
              <el-input
                size="mini"
                class="input"
                v-model="seniorData.log_file_size"
              ></el-input>
              <p style="font-size:12px;color:#666;">KB</p>
            </el-form-item>
            <el-form-item
              :label="$t('lang.repeater.logPriority')"
              prop="log_priority"
            >
              <el-select
                size="mini"
                class="input"
                v-model="seniorData.log_priority"
              >
                <el-option
                  :label="$t('lang.repeater.debug')"
                  value="8"
                ></el-option>
                <el-option
                  :label="$t('lang.repeater.info')"
                  value="7"
                ></el-option>
                <el-option
                  :label="$t('lang.repeater.notice')"
                  value="6"
                ></el-option>
                <el-option
                  :label="$t('lang.repeater.warn')"
                  value="5"
                ></el-option>
                <el-option
                  :label="$t('lang.repeater.error')"
                  value="4"
                ></el-option>
                <el-option
                  :label="$t('lang.repeater.fatal')"
                  value="3"
                ></el-option>
                <el-option
                  :label="$t('lang.repeater.alert')"
                  value="2"
                ></el-option>
                <el-option
                  :label="$t('lang.repeater.urgent')"
                  value="1"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('lang.repeater.logFile')">
              <el-button size="mini" @click="downClick" type="danger">{{
                $t("lang.repeater.download")
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-button
      type="danger"
      style="float:right;margin-right:20px;margin-top:20px;"
      @click="updateData"
      >{{ $t("lang.repeater.SaveApply") }}</el-button
    >
    <Edit :commData="commData" ref="comm"></Edit>
  </div>
</template>

<script>
//中继器
import { listConfig, getLog, updateConfig } from "@/api/configurationlist";
import { progressControl } from "@/api/particulars";
import Edit from "./components/edit.vue";
export default {
  name: "repeater",
  props: ["deviceSn", "deviceDid"],
  data() {
    var checkNumber = (rule, value, callback) => {
      if (!isNaN(Number(value))) {
        callback();
      } else {
        callback(new Error(this.$t("lang.repeater.numberRuleErr")));
      }
    };
    var checkServer = (rule, value, callback) => {
      let test = /(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5]):([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
      for (let i = 0; i < value.length; i++) {
        if (!test.test(value[i])) {
          callback(new Error(this.$t("lang.repeater.ipRuleErr")));
        }
      }
      callback();
      // if (test.test(value)) {
      //   callback();
      // } else {
      //   callback(new Error("格式不正确"));
      // }
    };
    var checkIp = (rule, value, callback) => {
      let test = /(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5]):([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
      let data = value.split(" ").filter((v) => v);
      console.log(data);
      for (let i = 0; i < data.length; i++) {
        if (test.test(data[i])) {
        } else {
          callback(new Error(this.$t("lang.repeater.ipRuleErr")));
        }
      }
      callback();
    };
    var checkPort = (rule, value, callback) => {
      let test = /^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/;
      if (test.test(value)) {
        callback();
      } else {
        callback(new Error(this.$t("lang.repeater.portRuleErr")));
      }
    };
    var checkName = (rule, value, callback) => {
      if (value >= 0 && value <= 31) {
        if (this.dataOption.find((item) => item.name == value)) {
          callback(new Error(this.$t("lang.repeater.nameRuleErr1")));
        } else {
          callback();
        }
      } else {
        callback(new Error(this.$t("lang.repeater.nameRuleErr2")));
      }
    };
    return {
      activeName: "first",
      serverOption: {
        enabled: "",
        net_proto: "",
        proto: "",
        hbt_interval: "",
        server: [],
        status: "",
        conn_num: "",
      },
      dataOption: [],
      serialData: [],
      seniorData: {},
      commData: {},
      deleteDataList: [],
      loading: false,
      // timer: null,
      rules: {
        hbt_interval: [
          {
            required: true,
            message: this.$t("lang.repeater.heartbeatRuleErr"),
            trigger: "blur",
          },
          { validator: checkNumber, trigger: "blur" },
        ],
        server: [{ validator: checkServer, trigger: "change" }],
      },
      rules2: {
        sendto: [{ validator: checkIp, trigger: "blur" }],
      },
      rules3: {
        port_recv: [{ validator: checkPort, trigger: "blur" }],
      },
      rules4: {
        name: [
          {
            required: true,
            message: this.$t("lang.repeater.numberRuleErr2"),
            trigger: "blur",
          },
          { validator: checkName, trigger: "blur" },
        ],
      },
      rules5: {
        tcp_keepalive_time: [
          {
            required: true,
            message: this.$t("lang.repeater.tcpRuleErr"),
            trigger: "blur",
          },
          { validator: checkNumber, trigger: "blur" },
        ],
        tcp_keepalive_interval: [
          {
            required: true,
            message: this.$t("lang.repeater.tcpRuleErr2"),
            trigger: "blur",
          },
          { validator: checkNumber, trigger: "blur" },
        ],
        tcp_keepalive_probes: [
          {
            required: true,
            message: this.$t("lang.repeater.tcpRuleErr3"),
            trigger: "blur",
          },
          { validator: checkNumber, trigger: "blur" },
        ],
        log_file_num: [
          {
            required: true,
            message: this.$t("lang.repeater.logRuleErr"),
            trigger: "blur",
          },
          { validator: checkNumber, trigger: "blur" },
        ],
        log_file_size: [
          {
            required: true,
            message: this.$t("lang.repeater.logRuleErr2"),
            trigger: "blur",
          },
          { validator: checkNumber, trigger: "blur" },
        ],
      },
      master: false,
      serial: false,
    };
  },
  async mounted() {
    this.loading = true;
    await this.getData();
    // if (!this.timer) {
    //   this.timer = setInterval(() => {
    //     this.getData();
    //   }, 10000);
    // }
    this.loading = false;
  },
  // beforeDestroy() {
  //   if (this.timer) {
  //     clearInterval(this.timer);
  //   }
  // },
  methods: {
    handleClick() {},
    addServer() {
      this.serverOption.server.push("");
    },
    removeClick(e) {
      this.serverOption.server = this.serverOption.server.filter(
        (v, index) => index != e - 1
      );
    },
    downClick() {
      getLog({
        did: this.deviceDid,
        sn: this.deviceSn,
        mess: "smartcat",
      }).then((res) => {
        const { data } = res;
        // 创建Blob对象（类文件对象）
        const blob = new Blob([data]);
        // let disposition = decodeURI(res.headers['content-disposition'])
        // 从响应头中获取文件名
        // let filename = disposition.substring(disposition.indexOf('fileName=') + 9, disposition.length)
        if ("download" in document.createElement("a")) {
          // 非IE下载
          // 创建隐藏下载超链接
          const elink = document.createElement("a");
          // 使用超链接的download属性下载文件
          elink.download = this.$t("lang.repeater.logFile");
          elink.style.display = "none";
          // 使用Blob创建一个指向类型化数组的URL
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          // 自定点击超链接
          elink.click();
          // 释放URL对象
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          //IE10+下载
          navigator.msSaveBlob(blob, filename);
        }
      });
    },
    editComClick(e) {
      this.commData = e;
      this.$refs["comm"].editShow = true;
    },
    addData() {
      this.dataOption.push({
        enabled: "",
        name: "",
        net_proto: "TCP",
        port_recv: "",
        port_send: "",
        proto: "Pass-Through",
        sendto: "",
        index: this.dataOption.length + 1,
        isAdd: true,
      });
    },
    removeData(e) {
      this.dataOption = this.dataOption.filter((v, index) => {
        if (index != e) {
          return v;
        } else {
          this.deleteDataList.push(v);
          return;
        }
      });
    },
    async updateData() {
      try {
        await this.$refs["port"].validate();
        await this.$refs["zh_name"].validate();
        await this.$refs["sendto"].validate();
        if (this.master) {
          this.$refs["server"].validate((v) => {
            if (v) {
              this.$refs["currency"].validate((v4) => {
                if (v4) {
                  this.loading = true;
                  let serial = [];
                  let service = {};
                  let data = [];
                  this.serialData.forEach((item, index) => {
                    serial.push({
                      section: item.comm,
                      options: {
                        baudrate: item.baudrate,
                        data_bits: item.data_bits,
                        stop_bits: item.stop_bits,
                        flow_ctrl: item.flow_ctrl,
                        enable_frame: item.enable_frame,
                        parity: item.parity,
                        frame_len: item.frame_len,
                      },
                      config: "smartcat",
                      action: 0,
                      index: [index],
                    });
                  });
                  service = {
                    section: "service",
                    config: "smartcat",
                    action: 0,
                    index: [0],
                    options: {
                      enabled: this.seniorData.enabled ? 1 : 0,
                      enable_debug: this.seniorData.enable_debug ? 1 : 0,
                      log_file_num: this.seniorData.log_file_num,
                      log_file_size: this.seniorData.log_file_size,
                      log_priority: this.seniorData.log_priority,
                      tcp_keepalive_time: this.seniorData.tcp_keepalive_time,
                      tcp_keepalive_interval: this.seniorData
                        .tcp_keepalive_interval,
                      tcp_keepalive_probes: this.seniorData
                        .tcp_keepalive_probes,
                    },
                  };
                  this.dataOption.forEach((item) => {
                    if (item.isAdd) {
                      data.push({
                        section: "mode",
                        config: "smartcat",
                        action: 1,
                        index: [item.index],
                        options: {
                          enabled: item.enabled ? "1" : "0",
                          upload_term: item.upload_term ? "1" : "0",
                          name: item.name,
                          net_proto: item.net_proto,
                          port_recv: item.port_recv,
                          port_send: item.port_recv,
                          sendto: item.sendto
                            .split(" ")
                            .filter((v) => v)
                            .join(" "),
                          proto: item.proto,
                        },
                      });
                    } else {
                      data.push({
                        section: "mode",
                        config: "smartcat",
                        action: 0,
                        index: [item.index],
                        options: {
                          enabled: item.enabled ? "1" : "0",
                          upload_term: item.upload_term ? "1" : "0",
                          name: item.name,
                          net_proto: item.net_proto,
                          port_recv: item.port_recv,
                          port_send: item.port_recv,
                          sendto: item.sendto
                            .split(" ")
                            .filter((v) => v)
                            .join(" "),
                          proto: item.proto,
                        },
                      });
                    }
                  });
                  this.deleteDataList.forEach((item) => {
                    data.push({
                      section: "mode",
                      config: "smartcat",
                      action: 2,
                      index: [item.index],
                      options: {
                        enabled: item.enabled ? "1" : "0",
                        name: item.name,
                        net_proto: item.net_proto,
                        port_recv: item.port_recv,
                        port_send: item.port_recv,
                        sendto: item.sendto,
                        proto: item.proto,
                      },
                    });
                  });
                  updateConfig(this.deviceSn, this.deviceDid, [
                    {
                      section: "master",
                      config: "smartcat",
                      action: 0,
                      index: [0],
                      options: {
                        enabled: this.serverOption.enabled ? "1" : "0",
                        net_proto: this.serverOption.net_proto,
                        proto: this.serverOption.proto,
                        hbt_interval: this.serverOption.hbt_interval,
                      },
                      lists: {
                        server: this.serverOption.server,
                      },
                    },
                    ...serial,
                    service,
                    ...data,
                  ]).then(async (res) => {
                    await this.getData();
                    await this.restart();
                    this.$message({
                      message: this.$t("lang.repeater.saveSuccess"),
                      type: "success",
                    });
                    this.loading = false;
                  });
                } else {
                  this.$message({
                    type: "warning",
                    message: this.$t("lang.repeater.seniorErr"),
                  });
                }
              });
            } else {
              this.$message({
                type: "warning",
                message: this.$t("lang.repeater.serverErr"),
              });
              return;
            }
          });
        } else {
          this.$refs["currency"].validate((v4) => {
            if (v4) {
              this.loading = true;
              let service = {};
              let data = [];
              service = {
                section: "service",
                config: "smartcat",
                action: 0,
                index: [0],
                options: {
                  enabled: this.seniorData.enabled ? 1 : 0,
                  enable_debug: this.seniorData.enable_debug ? 1 : 0,
                  log_file_num: this.seniorData.log_file_num,
                  log_file_size: this.seniorData.log_file_size,
                  log_priority: this.seniorData.log_priority,
                  tcp_keepalive_time: this.seniorData.tcp_keepalive_time,
                  tcp_keepalive_interval: this.seniorData
                    .tcp_keepalive_interval,
                  tcp_keepalive_probes: this.seniorData.tcp_keepalive_probes,
                },
              };
              this.dataOption.forEach((item) => {
                if (item.isAdd) {
                  data.push({
                    section: "mode",
                    config: "smartcat",
                    action: 1,
                    index: [item.index],
                    options: {
                      enabled: item.enabled ? "1" : "0",
                      upload_term: item.upload_term ? "1" : "0",
                      name: item.name,
                      net_proto: item.net_proto,
                      port_recv: item.port_recv,
                      port_send: item.port_recv,
                      sendto: item.sendto
                        .split(" ")
                        .filter((v) => v)
                        .join(" "),
                      proto: item.proto,
                    },
                  });
                } else {
                  data.push({
                    section: "mode",
                    config: "smartcat",
                    action: 0,
                    index: [item.index],
                    options: {
                      enabled: item.enabled ? "1" : "0",
                      upload_term: item.upload_term ? "1" : "0",
                      name: item.name,
                      net_proto: item.net_proto,
                      port_recv: item.port_recv,
                      port_send: item.port_recv,
                      sendto: item.sendto
                        .split(" ")
                        .filter((v) => v)
                        .join(" "),
                      proto: item.proto,
                    },
                  });
                }
              });
              this.deleteDataList.forEach((item) => {
                data.push({
                  section: "mode",
                  config: "smartcat",
                  action: 2,
                  index: [item.index],
                  options: {
                    enabled: item.enabled ? "1" : "0",
                    name: item.name,
                    net_proto: item.net_proto,
                    port_recv: item.port_recv,
                    port_send: item.port_recv,
                    sendto: item.sendto,
                    proto: item.proto,
                  },
                });
              });
              updateConfig(this.deviceSn, this.deviceDid, [
                service,
                ...data,
              ]).then(async (res) => {
                await this.getData();
                await this.restart();
                this.$message({
                  message: this.$t("lang.repeater.saveSuccess"),
                  type: "success",
                });
                this.loading = false;
              });
            } else {
              this.$message({
                type: "warning",
                message: this.$t("lang.repeater.seniorErr"),
              });
            }
          });
        }
      } catch (err) {
        this.$message({
          type: "warning",
          message: this.$t("lang.repeater.repeaterErr"),
        });
      }
    },
    getData() {
      return new Promise((reslove, reject) => {
        listConfig(this.deviceSn, this.deviceDid, [
          {
            section: "master",
            config: "smartcat",
            options: [
              { option: "enabled" },
              { option: "net_proto" },
              { option: "proto" },
              { option: "hbt_interval" },
              { option: "status" },
              { option: "conn_num" },
            ],
            lists: [
              {
                list: "server",
              },
              {
                list: "serial",
              },
            ],
          },
          {
            section: "mode",
            config: "smartcat",
            options: [
              { option: "enabled" },
              { option: "upload_term" },
              { option: "net_proto" },
              { option: "port_recv" },
              { option: "proto" },
              { option: "sendto" },
              { option: "port_send" },
              { option: "name" },
            ],
          },
          {
            section: "initconfig",
            config: "system",
            options: [{ option: "product_model" }, { option: "vendor_name" }],
          },
          {
            section: "service",
            config: "smartcat",
            options: [
              { option: "enabled" },
              { option: "enable_debug" },
              { option: "log_file_num" },
              { option: "log_file_size" },
              { option: "log_priority" },
              { option: "tcp_keepalive_time" },
              { option: "tcp_keepalive_interval" },
              { option: "tcp_keepalive_probes" },
              { option: "enable_master" },
              { option: "enable_serial" },
            ],
          },
        ]).then((res) => {
          if (!res.data.data.mess) {
            this.loading = false;
            return this.$message({
              type: "warning",
              message: this.$t("lang.repeater.repeaterErr2"),
            });
          }
          let server = res.data.data.mess[0].s_objects[0];
          let optionData = res.data.data.mess;
          let comm = optionData[0].s_objects[0].lists.serial;
          let commData = [];
          let senior = res.data.data.mess[3].s_objects[0].options;
          this.dataOption = [];
          res.data.data.mess[1].s_objects.forEach((item) => {
            if (item.sname != "master") {
              item.options.enabled == 0
                ? (item.options.enabled = false)
                : (item.options.enabled = true);
              item.options.upload_term == 0
                ? (item.options.upload_term = false)
                : (item.options.upload_term = true);
              item.options.index = item.index;
              this.dataOption.push(item.options);
            }
          });
          this.serverOption = {
            enabled: server.options.enabled == 0 ? false : true,
            net_proto: server.options.net_proto,
            proto: server.options.proto,
            hbt_interval: server.options.hbt_interval,
            server: server.lists.server,
            status: server.options.status,
            conn_num: server.options.conn_num,
          };
          senior.enabled == 0
            ? (senior.enabled = false)
            : (senior.enabled = true);
          senior.enable_debug == 0
            ? (senior.enable_debug = false)
            : (senior.enable_debug = true);
          senior.enable_master == 1
            ? (this.master = true)
            : (this.master = false);
          senior.enable_serial == 1
            ? (this.serial = true)
            : (this.serial = false);
          this.seniorData = senior;
          comm.forEach((v) => {
            commData.push({
              section: v,
              config: "smartcat",
              options: [
                { option: "name" },
                { option: "baudrate" },
                { option: "parity" },
                { option: "data_bits" },
                { option: "stop_bits" },
                { option: "flow_ctrl" },
                { option: "enable_frame" },
                { option: "timeout" },
                { option: "frame_len" },
              ],
            });
          });
          listConfig(this.deviceSn, this.deviceDid, [...commData]).then(
            (res2) => {
              this.serialData = [];
              res2.data.data.mess.forEach((v) => {
                this.serialData.push({
                  ...v.s_objects[0].options,
                  comm: v.s_objects[0].sname,
                });
              });
              reslove();
            }
          );
        });
      });
    },
    restart() {
      return new Promise((reslove, reject) => {
        progressControl(
          [{ process: "smartcat", action: "restart", type: 0 }],
          String(this.deviceDid),
          this.deviceSn
        ).then((res) => {
          reslove();
        });
      });
    },
    async refsh() {
      this.loading = true;
      await this.getData();
      this.loading = false;
    },
  },
  components: { Edit },
  filters: {
    customFilter(e) {
      let data;
      switch (e) {
        case "N":
          data = "None";
          break;
        case "E":
          data = "Even";
          break;
        case "M":
          data = "Mask";
          break;
        case "O":
          data = "Odd";
          break;
        case "S":
          data = "Space";
          break;
        case "R":
          data = "RTS/CTS";
          break;
        case "X":
          data = "XON/XOFF";
          break;
        case "D":
          data = "DTR/DSR";
          break;
        default:
          data = e;
          break;
      }
      return data;
    },
  },
};
</script>
<style scoped>
.currency p {
  font-size: 16px;
}
.input {
  width: 240px;
}
</style>
